import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, MessageCircle } from "lucide-react";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

export function FinalCTA() {
  const { ref, isVisible } = useScrollReveal();
  const whatsappNumber = "27732509394";
  const message = encodeURIComponent("Hi! I'm interested in your bookkeeping services.");

  return (
    <section className="py-20 lg:py-28 bg-gradient-animated relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      
      <div
        ref={ref}
        className={`container mx-auto px-4 relative z-10 scroll-reveal ${isVisible ? "revealed" : ""}`}
      >
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            Ready to Get Your Books Handled Properly?
          </h2>
          <p className="text-xl text-primary-foreground/80 mb-10">
            Let us take care of your bookkeeping, compliance, and peace of mind. 
            Get started with a free consultation today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/book-a-call">
              <Button 
                size="lg" 
                className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 gap-2 text-base px-8 h-14 btn-shimmer"
              >
                <Phone className="w-5 h-5" />
                Book a Call
              </Button>
            </Link>
            <a 
              href={`https://wa.me/${whatsappNumber}?text=${message}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-primary-foreground text-primary-foreground bg-transparent hover:bg-primary-foreground hover:text-primary gap-2 text-base px-8 h-14"
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp Us
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
